import { ChevronRight, LockKeyhole } from 'lucide-react';

import { Button } from '@app/shared/ui/atoms/Common';

interface StoneAbilityOldProps {
  icon: string;
  label: string;
  isLocked: boolean;
  onAbilityClick: () => void;
}

const StoneAbility = ({ icon, label, isLocked = true, onAbilityClick }: StoneAbilityOldProps) => {
  return (
    <Button
      onClick={onAbilityClick}
      className="flex w-full items-center justify-between py-3 text-sm font-semibold"
      variant="custom"
    >
      <span className="flex items-center gap-2 text-secondary-foreground">
        {icon} {label}
      </span>
      {!isLocked ? (
        <ChevronRight strokeWidth={1} className="text-white-foreground" />
      ) : (
        <LockKeyhole width={16} className="text-white-foreground" />
      )}
    </Button>
  );
};

export { StoneAbility };
